import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';

const ForgotPasswordPage = () => {
  const [phone, setPhone]     = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState('');
  const navigate = useNavigate();
  const { requestPasswordReset } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    const result = await requestPasswordReset(phone.trim());

    if (result.success) {
      // Pass phone to reset page
      navigate('/reset-password', { state: { phone_number: phone.trim() } });
    } else {
      setError(result.message);
    }
    setLoading(false);
  };

  return (
    <div className="page">
      <div className="card">
        <h2>Forgot Password</h2>
        <p className="subtitle">Enter your phone number and we'll send you an OTP to reset your password.</p>

        {error && <div className="error-box">{error}</div>}

        <form onSubmit={handleSubmit}>
          <input
            type="tel"
            value={phone}
            onChange={e => setPhone(e.target.value)}
            placeholder="Phone number (e.g. 0712345678)"
            required
            className="input-field"
          />
          <button type="submit" disabled={loading} className="primary-btn">
            {loading ? 'Sending OTP...' : 'Send OTP'}
          </button>
        </form>

        <p className="footer-link">
          Remember your password? <Link to="/login" className="link">Login</Link>
        </p>
      </div>

      <style>{`
        .page {
          min-height: 100vh; display: flex; align-items: center; justify-content: center;
          background: radial-gradient(at center, #49AFAF, #A8DFF4);
          font-family: Arial, sans-serif; padding: 20px;
        }
        .card {
          background: white; border-radius: 12px; padding: 40px 32px;
          max-width: 420px; width: 100%; text-align: center;
          box-shadow: 0 4px 24px rgba(0,0,0,0.1);
        }
        h2 { font-size: 24px; font-weight: bold; color: #111827; margin-bottom: 8px; }
        .subtitle { color: #6b7280; font-size: 14px; margin-bottom: 24px; line-height: 1.5; }
        .error-box {
          background: #fee2e2; border: 1px solid #f87171; color: #b91c1c;
          padding: 10px 14px; border-radius: 6px; margin-bottom: 16px; font-size: 14px;
        }
        .input-field {
          width: 100%; padding: 12px 16px; border: 1px solid #d1d5db;
          border-radius: 6px; font-size: 16px; background: white;
          box-sizing: border-box; margin-bottom: 16px;
        }
        .input-field:focus { outline: none; border-color: #3b82f6; }
        .primary-btn {
          width: 100%; padding: 13px; background: #3b82f6; color: white;
          border: none; border-radius: 50px; font-size: 16px; font-weight: 500;
          cursor: pointer; transition: background 0.2s;
        }
        .primary-btn:hover { background: #2563eb; }
        .primary-btn:disabled { background: #9ca3af; cursor: not-allowed; }
        .footer-link { margin-top: 20px; font-size: 14px; color: #6b7280; }
        .link { color: #3b82f6; text-decoration: none; }
        .link:hover { text-decoration: underline; }
      `}</style>
    </div>
  );
};

export default ForgotPasswordPage;
